export async function runWithConcurrency(items, worker, options = {}) {
  const { concurrency = 3, isAborted = () => false, onSettle, staggerMs = 0 } = options;
  const results = new Array(items.length);
  let nextIndex = 0;

  let completed = 0;
  async function runOne() {
    for (;;) {
      if (isAborted()) return;
      const index = nextIndex++;
      if (index >= items.length) return;
      const item = items[index];
      let entry;
      try {
        const value = await worker(item, index);
        entry = { index, item, status: 'fulfilled', value };
      } catch (error) {
        entry = { index, item, status: 'rejected', error };
      }
      results[index] = entry;
      completed++;
      if (onSettle) onSettle({ ...entry, completed, total: items.length });
    }
  }

  const workerCount = Math.max(1, Math.min(concurrency, items.length));
  await Promise.all(
    Array.from({ length: workerCount }, (_, slot) =>
      (staggerMs > 0 ? new Promise(r => setTimeout(r, slot * staggerMs)) : Promise.resolve())
        .then(runOne)
    )
  );

  for (let i = 0; i < items.length; i++) {
    if (results[i] === undefined) results[i] = { index: i, item: items[i], status: 'skipped' };
  }
  return results;
}
